<template>
  <div 
    v-fades="{ showEnLayer }"
    class="lang-notice">
    <div class="lang-notice__container">
      <h3>Welcome to Glaxi Pane</h3>
      <span 
        @click="visitEnglish"
        class="glaxi__link">Visit the site</span>
      <div>or</div>
      <!--
      <router-link 
        :to="{ name: `${defaultLang}.home` }"
        class="underline_link">
          visita il sito in Italiano
      </router-link>
      -->
      <span 
        @click="$_goItalian()"
        class="underline_link">
          visita il sito in Italiano
      </span>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import { TweenLite } from 'gsap/TweenLite'
import language from '@/views/LangWrapper/languages'

export default {
  name: 'EnglishLayer',
  data: () => ({
    goEnglish: true,
    defaultLang: language[0],
  }),
  methods: {
    visitEnglish () {
      this.goEnglish = false
    },
    ...mapMutations([
      'changeLanguage'
    ]),
    $_goItalian () {
      this.changeLanguage('it')
      this.$router.push({ name: 'it.home' })
    }
  },
	computed: {
    ...mapGetters([
      'lang'
    ]),
    showEnLayer: {
      get () {
        if (this.lang === 'en' && this.goEnglish) return true
        return false
      }
    }
  },
  directives: {
    'fades': {
      inserted (el, binding) {
        const { showEnLayer } = binding.value
        const ref = el
        if (showEnLayer) {
          el.style.visibility = "visible"
          TweenLite.to(el, 0, {opacity: 1})
        }
        else TweenLite.to(el, .8, {opacity: 0, onComplete: () => ref.style.visibility = "hidden"})
      },
      componentUpdated (el, binding) {
        const { showEnLayer } = binding.value
        const ref = el
        if (showEnLayer) {
          el.style.visibility = "visible"
          TweenLite.to(el, .4, {opacity: 1})
        }
        else TweenLite.to(el, 0.8, {opacity: 0, onComplete: () => ref.style.visibility = "hidden"})
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./layer.scss";
</style>
  